"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200",
    height: "200",
    viewBox: "0 0 200 200"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "171.08243 63.31399 180.63779 72.86937 180.66431 72.85581 200 63.31399 180.66431 53.77335 180.66431 53.77218 180.63663 53.75862 171.08243 63.31399"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "157.75669 53.77124 138.42043 63.31366 157.75669 72.8543 157.75669 72.85608 157.78437 72.8696 167.33797 63.31366 157.7826 53.7583 157.75669 53.77124"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "169.0729 65.06242 159.51813 74.61779 159.53169 74.64371 169.0729 93.97999 178.61413 74.64431 178.61533 74.64431 178.62886 74.61721 169.0735 65.06242 169.0729 65.06242"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "169.07386 32.64795 159.53203 51.98366 159.53143 51.98366 159.5185 52.01134 169.07326 61.56552 169.07386 61.56552 178.62863 52.01074 178.61567 51.98426 169.07386 32.64795"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.31997,106.12737s-6.31997,0-6.31997,6.63709v47.95351s0,6.63707,6.31998,6.63707H51.97649s6.32581,0,6.32581-6.63707v-47.95351s0-6.63709-6.32581-6.63709H6.31997Z",
    style: {
      fill: '#f9d614'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.28274,106.12737s-6.31998,0-6.31998,6.63709v47.95351s0,6.63707,6.31998,6.63707h45.65653s6.32579,0,6.32579-6.63707v-47.95351s0-6.63709-6.32579-6.63709h-45.65653Z",
    style: {
      fill: '#e6007e'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M146.24549,106.12737s-6.31996,0-6.31996,6.63709v47.95351s0,6.63707,6.31996,6.63707h45.65654s6.32579,0,6.32579-6.63707v-47.95351s0-6.63709-6.32579-6.63709h-45.65654Z",
    style: {
      fill: '#95c11f'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.31997,32.64497s-6.31997,0-6.31997,6.63708v47.95658s0,6.63708,6.31998,6.63708H51.97649s6.32581,0,6.32581-6.63708V39.28205s0-6.63708-6.32581-6.63708H6.31997Z",
    style: {
      fill: '#e84e0f'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.28274,32.64497s-6.31998,0-6.31998,6.63708v47.95658s0,6.63708,6.31998,6.63708h45.65653s6.32579,0,6.32579-6.63708V39.28205s0-6.63708-6.32579-6.63708h-45.65653Z",
    style: {
      fill: '#009fe3'
    }
  }));
};

exports["default"] = _default;